import React from 'react'
import { ProjectsPickerWrapper } from './ProjectPickerContent.styles'
import { WorkspaceTreeNodes } from './TreeNode.workspaces'
import { useTreeSearch } from './search'
import { SearchTreeNodes } from './search/TreeNode.search'

export const ProjectPickerContent = () => {
  const { searchDebounced: search } = useTreeSearch()
  return (
    <ProjectsPickerWrapper>
      {search.name ? (
        <SearchTreeNodes search={search} key={search.name} />
      ) : (
        <WorkspaceTreeNodes />
      )}
    </ProjectsPickerWrapper>
  )
}
